import React from "react";
import { ShieldAlert } from "lucide-react";
import { Panel } from "@/components/common/Panel";
import { useCapabilities } from "@/lib/capabilities";

/** Gates an entire page behind a platform module (Dynamic RBAC). Renders
 * children immediately while capabilities are still loading (avoids a
 * flash-of-restricted for legitimate users) — the backend independently
 * enforces the same module check on every API call regardless. */
export function ModuleGate({ module, label, children }) {
    const { caps } = useCapabilities();
    if (caps && !caps.modules?.includes(module)) {
        return (
            <Panel eyebrow="Restricted" title={label || "Module"}>
                <div data-testid={`module-gate-restricted-${module}`} className="flex items-start gap-3 py-4">
                    <ShieldAlert size={18} className="text-rose-400 shrink-0 mt-0.5" />
                    <p className="text-sm text-slate-400">
                        Your current role(s) do not grant access to <span className="font-mono text-cyan-300">{label || module}</span>.
                        Ask a platform admin to add this module to one of your roles.
                    </p>
                </div>
            </Panel>
        );
    }
    return children;
}
